import React, { useEffect, useState } from "react";
import Overview from "./Overview";
import Engagement from "./Engagement";
import AudienceInf from "./AudienceInf";
import InfPosts from "./InfPosts";
import InfReels from "./InfReels";
import { useDispatch, useSelector } from "react-redux";
import { fetchDiscoverProfileData } from "../../features/discover/discoverSlice";
import { useLocation } from "react-router-dom";

const InfluencerProfileAnalysis = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("overview");

  const [infDisAnalysis, setInfDisAnalysis] = useState("");

  const { username, channelName } = location.state || {};

  const { discoverData, status, error } = useSelector(
    (state) => state?.discoverData,
  );

  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "engagement", label: "Engagement" },
    { id: "audience", label: "Audience" },
    { id: "posts", label: "Posts" },
    { id: "reels", label: "Reels" },
  ];

  console.log("channel name ==>", channelName, "user name ==>, username");
  useEffect(() => {
    const payload = {
      username: username,
      platform: channelName,
      unlock: true,
      uploadImageInBackGround: false,
    };

    dispatch(fetchDiscoverProfileData(payload));
  }, [dispatch]);

  useEffect(() => {
    console.log("activeTab activeTab discoverData==>", discoverData);
  }, [discoverData]);

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Profile Report</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="javascript: void(0);">CRM</a>
                </li>
                <li className="breadcrumb-item active">Influencer Discovery</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card p-4">
            <div className="d-flex align-items-center mb-4">
              <a href="#" className="me-4 text-danger">
                <i className="ri-arrow-left-line"></i> BACK
              </a>
              <ul className="nav nav-tabs flex-nowrap overflow-auto border-0 w-100">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.id}>
                    <button
                      type="button"
                      className={`nav-link ${
                        activeTab === tab.id ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            {activeTab === "overview" && <Overview />}
            {activeTab === "engagement" && <Engagement />}
            {activeTab === "audience" && <AudienceInf />}
            {activeTab === "posts" && <InfPosts />}
            {activeTab === "reels" && <InfReels />}
          </div>
        </div>
      </div>
    </>
  );
};

export default InfluencerProfileAnalysis;
